<script setup>
    import { watch, onMounted, ref } from 'vue';
    import Signature from '../components/SignatureComponent.vue';
    import FileUpload from '../components/FileUpload.vue';
    import GetStartedModal from '../components/modals/GetStartedModal.vue';
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';

    import { imageUrl, fileUrl, uploadUrl } from '@/composables/http';
    import useMyProfile from '@/composables/useMyProfile';
  
    import CustomPopup from '../components/modals/CustomPopup.vue';

    import EulaAndAnnouncementModal from '../components/modals/EulaAndAnnouncementModal.vue';

    import useTerms from '../composables/useTerms';
    import TermChangeList from '../components/TermChangeList.vue';
    import FirstTimePopup from '../components/modals/FirstTimePopup.vue';

    const { loading, data, showGetStartedModal, signatureFile, signaturePad, read, onSave, onSaveSignatureUpload, onSaveSignaturePad, saveLogo } = useMyProfile();
 
    //setup popup varibles.
    const showFirstTimePopup = ref(false); // Controls popup visibility
    const firstTimePopupTitle = ref('Welcome To Contractly!'); // Popup title
    const firstTimeContent = ref('Please fill out your profile in order to get started. <br>The following fields in yellow are missing; Business Name, GST/HST Registration Number, Your City, Your Province, Your Postal Code<br/>And don’t forget to add your signature!'); // Popup content
    const firstTimeConfirmText = ref('OK'); // Confirm button text
    const firstTimeCurrentConfirmAction = ref(null);

    // Reactive properties
    const showPopup = ref(false); // Controls popup visibility
    const popupIcon = ref(null); // Icon for the popup
    const popupIconSrc = ref(null); // Custom icon source (optional)
    const iconColor = ref(''); // Icon color
    const popupTitle = ref(''); // Popup title
    const content = ref(''); // Popup content
    const cancelText = ref('');
    const confirmText = ref(''); // Confirm button text
    const currentConfirmAction = ref(null);
    const confirmButtonType = ref(''); // Button type for confirmation

    const autoClose = ref(true);

    const trialEndDate = ref('');

    const isFirstTimeSave = ref(false);
 
    function showCustomPopup(title, message, _cancelText, _confirmText, _confirmButtonType) {

        showPopup.value = true;
        popupTitle.value = title;
        content.value = message;

        cancelText.value = _cancelText;

        confirmText.value = _confirmText;

        confirmButtonType.value = _confirmButtonType;

        if (_confirmButtonType == 'error') {
            popupIconSrc.value = require('@/assets/images/icons/ErrorIcon.png');
        } else {
            //popupIconSrc.value = require('@/assets/images/icons/InfoIcon.png');
          
        }
    }
    function closePopup() {
        showPopup.value = false;

        // Reset values to defaults
        popupTitle.value = '';
        content.value = '';
        confirmText.value = '';
        confirmButtonType.value = '';

        popupIconSrc.value = '';
    }

    function displayFirstTimePopup() {
        showFirstTimePopup.value = true;
    }
    function closeFirstTimePopup() {
        showFirstTimePopup.value = false;

        firstTimeContent.value = '';
        firstTimePopupTitle.value = '';
    }

    function checkFields() {
        //console.log("data.value", data.value);
         
        if (!data.value.Address) {

            showCustomPopup("Please enter the address field", "", null, "OK", "error");
            //window.$message.error('Please enter the address field');
            return;
        }
        if (!data.value.City) {
            showCustomPopup('Please enter the city field', "", null, "OK", "error");
            return;
        }

        if (!data.value.PostalCode) {
            showCustomPopup('Please enter the postal code', "", null, "OK", "error");
            return;
        }
        if (!data.value.Province) {
            showCustomPopup('Please choose the province', "", null, "OK", "error");
            return;
        }
        if (!data.value.Phone) {
            showCustomPopup('Please enter the business phone number', "", null, "OK", "error");
            return;
        }
        if (!data.value.Email) {
            showCustomPopup('Please enter the business email', "", null, "OK", "error");
            return;
        }
        if (!data.value.FirstName) {
            showCustomPopup('Please enter the first name', "", null, "OK", "error");
            return;
        }
        if (!data.value.LastName) {
            showCustomPopup('Please enter the last name', "", null, "OK", "error");
            return;
            
        }

        

        signaturePad.value.onPadAgree();
        //onSave(onSaveCallback);

    }

    const onSaveCallback = (res)=>{
        if (res?.Type == 200) {
            //console.log("OK");

            //showCustomPopup("Profile Saved!", "", null, "OK", "success");
            showCustomPopup("Profile Saved!", "", null, "OK", "success");
            if(isFirstTimeSave.value){
                setTimeout(() => {
                    isFirstTimeSave.value = false;
                    firstTimeContent.value = 'Please go to the My Projects/Client section and add your first project. But in order to send an Agreement to your Clients or Sub-Contractor you must be subscribed.';
                    firstTimePopupTitle.value = 'Next Steps';
                    displayFirstTimePopup();
                }, 2000);
            }
             

            setTimeout(() => {
                signaturePad.value.refresh();
                if (data.value.Signature != null) {
                    previewImage.value = imageUrl(data.value.Signature);
                }
            }, 500);

        } else {
            //error res?.Content
            showCustomPopup(res?.Content, "", null, "OK", "error");
            //console.log("error");
        }
    }

    function clearLogoPreview() {
        data.value.Photo = "";
    }
    function handleLogoFileDrop(event) {
        const file = event.dataTransfer.files[0];
        //console.log("handleLogoFileDrop", file);

        if (file && isValidImage(file)) {
            //previewImage.value = URL.createObjectURL(file);
            //signatureFile.value = file;
            //onSaveSignatureUpload(file);
            saveLogo(file);
        } else {
            showCustomPopup('Please upload a proper image file', "", null, "OK", "error");
        }
        /*
        if (files.length) {
            uploadFile(files[0]);
        }
        */
    }

    function handleLogoFileChange(event) {
        const file = event.target.files[0];

        //console.log("handleLogoFileChange", file);

        if (file && isValidImage(file)) {
            //previewImage.value = URL.createObjectURL(file);
            //onSaveSignatureUpload(file);

            saveLogo(file);
        }
    }
   

    const previewImage = ref(null);
    function clearPreview() {
        previewImage.value = null;
        data.value.Signature = null;

    }
    function isValidImage(file)   {
        const validTypes = ['image/png', 'image/jpeg', 'image/gif'];
        return validTypes.includes(file.type);
    }

    function handleFileDrop(event)  {
        const file = event.dataTransfer.files[0];
        //console.log("handleFileDrop", file);

        if (file && isValidImage(file)) {
            previewImage.value = URL.createObjectURL(file);
            //signatureFile.value = file;
            onSaveSignatureUpload(file);
        } else {
            showCustomPopup('Please upload a proper image file', "", null, "OK", "error");
        }
        /*
        if (files.length) {
            uploadFile(files[0]);
        }
        */
    }

    function handleFileChange(event) {
        const file = event.target.files[0];
        if (file && isValidImage(file)) {
            previewImage.value = URL.createObjectURL(file);
            onSaveSignatureUpload(file);
        }

    }

    function onSignatureCancel() {
        clearPreview();
    }

    function sameEmailChange() {
        if (data.value.SameEmail) {
            data.value.AltEmail = data.value.Email;
        }
    }
    function samePhoneChange() {
        if (data.value.SamePhone) {
            data.value.AltPhone = data.value.Phone;
        }
    }

    function onSignature() {

        onSave(onSaveCallback);
         
    }

   
    function beforeOnSaveSignaturePad(file) {
        if (file == null) {

            if(!data.value.Signature) {
                showCustomPopup('Please provide your signature.', "", null, "OK", "error");
                return;
            }

            onSave(onSaveCallback);
        } else {
            onSaveSignaturePad(file, onSignature);
        }
       
    }
 
    onMounted(() => {

        
        setTimeout(() => {
            if (data.value.Signature != null) {
                previewImage.value = imageUrl(data.value.Signature);
               
            }else{
                isFirstTimeSave.value = true;
                displayFirstTimePopup();
            }
 
            //console.log("my profile", data.value);

            if (window.$core.data.UserInfo.Metadata.Subscription.Plan.Type == 1)
                trialEndDate.value = "Enjoy your Free Trial ending on " + window.$core.data.UserInfo.Metadata.TrialEndDate;

           if (window.$core.data.UserInfo.Metadata?.IsRestricted )
                trialEndDate.value = "In order to generate agreements to your Clients and Sub-Contractors you must first subscribe." ;

            

            //console.log("userinfo", window.$core.data.UserInfo);
        }, 1000);
      
    });

</script>



<template>
    <div class="wrapper">
        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }" v-if="data!=null">


            <div class="top" style="height:60px;"> </div>

            <h4 class="mb-6 font-semibold">My Profile</h4>
            <div v-if="trialEndDate" style="text-align: center; margin-bottom: 16px; color: red;">{{trialEndDate}}</div>
            <div class="bg-gray-100 min-h-screen flex flex-col  p-2 rounded-xl">
                <div class="info" style="font-size: 16px;">Please fill out all the sections below to ensure your agreements are made accurately.</div>


                <div class="  clearfix">

                    <div class="box row">
                        <div class="col-12" style="display:flex; flex-wrap: wrap; gap: 8px;">
                            <div style="flex: 1; min-width: 200px;">
                                <div>
                                    <label class="form-label">Your Business Name (If Any)</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="data.Name" placeholder="Business Name" style="max-width: 500px;">
                                        <div class="yellow-cover" v-if="!data.Name " style="max-width: 500px;"></div>
                                    </div>

                                </div>
                                <div>
                                    <label class="form-label">GST/HST Registration Number (9 digits only If Any)</label>
                                    <div style="display: flex; gap: 8px; align-items: center;">
                                        <div class="input-group" style="max-width: 200px;">
                                            <input class="form-control" style="max-width: 200px;" v-model="data.GstNumber" placeholder="9 digits number" type="text" pattern="\d*" maxlength="9">
                                            <div class="yellow-cover" v-if="!data.GstNumber " style="max-width: 200px;"></div>
                                        </div>

                                        <n-popover trigger="hover">
                                            <template #trigger>
                                                <span class="material-icons">help</span>
                                            </template>
                                            <span>If you collect and remit GST/HST, <br>please enter your 9-digit number here</span>
                                        </n-popover>
                                    </div>

                                </div>
                            </div>
                            <div class="MoveToTop">
                                <!-- Drag and Drop Area -->
                                <div @drop.prevent="handleLogoFileDrop" @dragover.prevent
                                     class="drag-drop-area"
                                     style="max-width: 200px; margin: 16px auto;"
                                     :style="{ border: data.Photo ? 'none' : '2px dashed #aaa', padding: data.Photo ? '0' : '20px', textAlign: data.Photo ? 'center' : 'center', cursor: 'pointer'}"
                                     @click="$refs.logoFile.click()">
                                    <p v-if="!data.Photo" style="margin-bottom: 0; ">Drag and drop your Logo here, or click to browse</p>

                                    <div v-if="data.Photo" class="image-container">
                                        <img :src="`${imageUrl(data.Photo)}`" alt="Preview" class="preview-image" />
                                        <div class="cancel-icon" @click.stop="clearLogoPreview">
                                            <svg class="bi bi-x" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
                                                <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
                                            </svg>
                                        </div>
                                    </div>

                                </div>
                                <div style="font-size:10px; max-width:200px;">If you would like to display your logo on your agreement, please upload an acceptable format here such as; JPEG, Gif, PNG</div>
                                <!-- Hidden File Input (fallback for manual selection) -->
                                <input ref="logoFile" type="file" accept=".png,.jpg,.gif" @change="handleLogoFileChange" style="display: none;" />
                            </div>


                        </div>

                        <div class="col-6">
                            <label class="form-label">First Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="data.FirstName" placeholder="First Name">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Last Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="data.LastName" placeholder="Last Name">
                        </div>

                        <div class="col-7 col-md-8">
                            <label class="form-label">Address <span class="mandatory">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="data.Address" placeholder="Address">
                                <div class="yellow-cover" v-if="!data.Address"></div>
                            </div>

                        </div>
                        <div class="col-5 col-md-4">
                            <label class="form-label">Unit</label>
                            <input type="text" class="form-control" v-model="data.Unit" placeholder="Unit">
                        </div>

                        <div class="col-7 col-md-8">
                            <label class="form-label">City <span class="mandatory">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="data.City" placeholder="City">
                                <div class="yellow-cover" v-if="!data.City"></div>
                            </div>

                        </div>
                        <div class="col-5 col-md-4">
                            <label class="form-label">Province <span class="mandatory">*</span></label>

                            <div class="input-group">
                                <select class="form-select" v-model="data.Province">
                                    <option value="">Please Select</option>
                                    <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                                </select>
                                <div class="yellow-cover" v-if="!data.Province || data.Province === ''"></div>
                            </div>


                        </div>

                        <div class="col-6 col-sm-4">
                            <label class="form-label">Postal Code <span class="mandatory">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="data.PostalCode" placeholder="Postal Code" maxlength="7">
                                <div class="yellow-cover" v-if="!data.PostalCode"></div>
                            </div>

                        </div>
                        <div class="col-6  col-sm-4 offset-sm-4">
                            <label class="form-label">Fax</label>
                            <input class="form-control" v-model="data.Fax" placeholder="Fax" type="text" pattern="\d*" maxlength="10">
                        </div>

                        <div class="col-7 col-sm-6">
                            <label class="form-label">Business Phone No. – (This is where you will receive all SMS notifications)<span class="mandatory">*</span></label>
                            <input class="form-control" v-model="data.Phone" placeholder="Business Phone No." type="text" pattern="\d*" maxlength="10">
                        </div>

                        <div class="col-5 col-sm-4 offset-sm-2" style="align-self: end;">
                            <label class="form-label">Ext</label>
                            <input type="number" class="form-control" v-model="data.PhoneExtension" placeholder="Ext">
                        </div>

                        <div class="col-12 col-sm-6">
                            <label class="form-label">Business Email - (This is where you will receive all Email notifications)<span class="mandatory">*</span></label>
                            <input type="email" class="form-control" v-model="data.Email" placeholder="Business Email">
                        </div>
                        <div class="col-0 col-sm-2"></div>
                        <div class="col-6 col-sm-6" style="display:none;">
                            <label class="form-label">Contact First Name <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="data.AltFirstName" placeholder="First Name">
                        </div>
                        <div class="col-6 col-sm-6" style="display:none;">
                            <label class="form-label">Contact Last Name <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="data.AltLastName" placeholder="Last Name">
                        </div>


                        <div class="col-12 hidden">
                            <label class="form-label col-3">Phone No </label>
                        </div>
                        <div class="col-6 col-sm-6 hidden">
                            <input class="form-control col-6" v-model="data.AltPhone" placeholder="Phone Number" type="text" pattern="\d*" maxlength="10">
                        </div>

                        <div class="col-6 hidden">

                            <div class="form-check form-check-inline">
                                <input @change="samePhoneChange" type="checkbox" v-model="data.SamePhone" id="samePhone" class="form-check-input" />
                                <label for="samePhone" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as the business phone number above</label>
                            </div>
                        </div>

                        <div class="col-12 hidden">
                            <label class="form-label col-3">Email </label>
                        </div>

                        <div class="col-6 hidden">
                            <input type="text" class="form-control" v-model="data.AltEmail" placeholder="Email">
                        </div>
                        <div class="col-6 hidden">

                            <div class="form-check form-check-inline">
                                <input @change="sameEmailChange" type="checkbox" v-model="data.SameEmail" id="sameEmail" class="form-check-input" />
                                <label for="sameEmail" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as the business email address above</label>
                            </div>
                        </div>




                        <div class="col-12">
                            <div class="width-100p">
                                <h6 style="text-align:center; font-weight:bold; margin:16px 0px;">Your Signature to use on your agreements <span class="mandatory">*</span></h6>


                                <h6 style="text-align:center;  margin:16px 0px;">Upload a Signature file (PNG, JPEG, GIF)</h6>


                                <!-- Drag and Drop Area -->
                                <div @drop.prevent="handleFileDrop" @dragover.prevent
                                     class="drag-drop-area"
                                     style="max-width: 300px; margin: 16px auto;"
                                     :style="{ border: previewImage ? 'none' : '2px dashed #aaa', padding: previewImage ? '0' : '20px', textAlign: previewImage ? 'center' : 'center', cursor: 'pointer'}"
                                     @click="$refs.signatureFile.click()">
                                    <p v-if="!previewImage" style="margin-bottom: 0; ">Drag and drop your signature image here, or click to browse</p>

                                    <div v-if="previewImage" class="image-container">
                                        <img :src="previewImage" alt="Preview" class="preview-image" />
                                        <div class="cancel-icon" @click.stop="clearPreview">
                                            <svg class="bi bi-x" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
                                                <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
                                            </svg>
                                        </div>
                                    </div>

                                </div>

                                <!-- Hidden File Input (fallback for manual selection) -->
                                <input ref="signatureFile" type="file" accept=".png,.jpg,.gif" @change="handleFileChange" style="display: none;" />
                                <br />

                                <!--
                            <div class="btn btn-positive" @click="onSignatureSave">Save</div>


                            <div v-if="data.Signature != '' && data.Signature != null">

                                <div class="SingnaturePreview">
                                    <div style="font-weight:bold; padding:8px;">Uploaded files</div>
                                    <img :src="imageUrl(data.Signature, 350, 150)" />
                                </div>
                            </div>
                             -->
                                <h6 style="font-weight:800; text-align:center; margin: 16px; margin-bottom: 32px;">OR</h6>

                                <Signature ref="signaturePad" okButton="Save" @cancel-event="onSignatureCancel" @agree-event="beforeOnSaveSignaturePad"></Signature>
                            </div>
                        </div>

                        <div class="col-12 ">
                            <div style="color:red; font-size:12px; margin-left:10px; font-weight:bold; margin-top:16px; margin-bottom:16px;">* Mandatory information</div>
                        </div>

                        <div class="col-12" style="text-align:right;">

                            <div class="btn btn-positive" @click="checkFields">Save</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <GetStartedModal v-show="showGetStartedModal" @close-modal="showGetStartedModal = false" />


        <CustomPopup :visible="showPopup"
                     :icon="popupIcon"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     cancelText="null"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     :autoClose="autoClose"
                     @cancel="closePopup" />


        <EulaAndAnnouncementModal />
        <FirstTimePopup :visible="showFirstTimePopup"
                        :title="firstTimePopupTitle"
                        :content="firstTimeContent"
                        :confirmText="firstTimeConfirmText"
                        :confirmAction="firstTimeCurrentConfirmAction"
                        @cancel="closeFirstTimePopup" />

        <TermChangeList />
    </div>

</template>


<style scoped>
    #app {
        height: 100vh;
    }

    .nav-link {
        color: white;
        width: 100%;
    }

     

    .container {
        min-height:100vh;
        height: 100%;
    }

    .MoveToTop{order:0;}
    .info {
        font-size: 12px;
        color: gray;
        margin-left: 10px;
    }

    .drag-and-drop-area {
        border: 2px dashed #ccc;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        
    }

    .image-container {
        max-height: 150px;
        width: fit-content;
        position: relative;
        margin: auto;
    }

    .preview-image {
        max-width: 100%;
        max-height: 150px;
        border-radius: 10px;
        border:1px solid #ccc;
        background-color:white;
        margin: auto;
    }

    .upload-prompt {
        padding: 20px;
        color: #aaa;
    }

    .cancel-icon {
        position: absolute;
        padding: 0px;
        background-color: red;
        top: 5px;
        right: 5px;
        cursor: pointer;
        width: 20px;
        height: 20px;
        color: white;
        line-height: 17px;
        border-radius: 50%;
    }

    .input-group{
        position: relative;
    }
    .yellow-cover{
        position: absolute;
        top: 0;
        left: 0;
        background-color: yellow;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        pointer-events: none; /* Allow clicks to pass through */
        border-radius: 4px !important;
    }


    @media (max-width: 600px) {
        /* Mobile version */
        .MoveToTop {
            order: -1; 
            width: 100%;
        }
        .MoveToTop div{max-width: unset !important; margin: auto;}
        .image-container{max-height: 200px; margin: auto;}
        .preview-image{max-height: 200px; }
    }

</style>

